import {
  createSlice,
  createListenerMiddleware,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { conversationService } from "./api";
import type { RootState } from "../../store";

type ChatStreamStatus = "ready" | "submitted" | "streaming" | "error";

interface ConversationStatusState {
  chatStreamStatus: ChatStreamStatus | null;
  conversationId: string | null;
}

const initialState: ConversationStatusState = {
  chatStreamStatus: null,
  conversationId: null,
};

export const conversationSlice = createSlice({
  name: "conversationStatus",
  initialState,
  reducers: {
    setChatStreamStatus(
      state,
      action: PayloadAction<{ status: ChatStreamStatus; conversationId: string }>,
    ) {
      state.chatStreamStatus = action.payload.status;
      state.conversationId = action.payload.conversationId;
    },
  },
});

export const { setChatStreamStatus } = conversationSlice.actions;

export const selectChatStreamStatus = (state: RootState) =>
  state.conversationStatus.chatStreamStatus;

export const selectIsChatReady = (state: RootState) =>
  state.conversationStatus.chatStreamStatus === "ready" ||
  state.conversationStatus.chatStreamStatus === null;

// Invalidate conversation summary cache when chat stream completes,
// since streaming bypasses the createMessage RTK mutation and its invalidation tags
export const conversationStatusListener = createListenerMiddleware();

conversationStatusListener.startListening({
  actionCreator: setChatStreamStatus,
  effect: (action, listenerApi) => {
    if (action.payload.status === "ready") {
      listenerApi.dispatch(
        conversationService.util.invalidateTags([
          { type: "ConversationSummary", id: action.payload.conversationId },
        ]),
      );
    }
  },
});
